import React, { useState, useEffect } from 'react';
import { Button, Toast, Modal } from '@roo/roo';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { revokeProject, downloadProject } from '@assets/apis/apply';
import { useUserData } from '@components/UserData';
import { useSimpleContext } from '@pages/applyView/_context';
import { getS3Token } from '@assets/apis/base';
import { genStr, toastFail, toastSuccess } from '@utils/utils';
import { file_name_separator } from '@components/UploadPro';

import htmlToPDF from './html2PDF';

const axiosInstance = axios.create({ withCredentials: false, timeout: 20000 });

const UserAction = () => {
  const history = useHistory();

  const {
    applyFlag,
    refreshUserData,
  } = useUserData();

  const {
    state: {
      formType,
      projectNo,
      token,
      recommendUploadStatus,
    },
    update,
  } = useSimpleContext((t) => [t.formType, t.projectNo, t.token, t.recommendUploadStatus]);

  const [
    downloadBtnConfig,
    setDownloadBtnConfig,
  ] = useState({
    text: '下载',
    disabled: false,
  });

  const revoke = () => {
    if (recommendUploadStatus === 'uploaded') {
      toastFail('推荐信已上传，当前申报不可撤回');
      return;
    }
    Modal.confirm({
      title: '确认撤回申报',
      onConfirm: async () => {
        try {
          await revokeProject();
          toastSuccess('撤回成功');
          await refreshUserData();
          history.replace({ pathname: `/apply/${formType}` });
        } catch (err) {
          toastFail('撤回失败');
        }
      },
      children: (
        <p>确定后申报将被撤回，如需再次申报，请在申报截止日期前完成提交。</p>
      ),
      confirmText: '确定',
      cancelText: '取消',
    });
  };

  // 更新按钮状态
  const updateButtonState = (text, disabled) => {
    setDownloadBtnConfig({
      text,
      disabled,
    });
  };

  // 生成PDF文件
  const generatePDF = () => {
    updateButtonState('生成中', true);
    return new Promise((resolve, reject) => {
    const selector = '#pdf-container';
    const container = document.querySelector(selector);
    if (!container) {
      console.error('未找到指定的元素:', selector);
      return;
    }
      const pdfOptions = {
        fileName: projectNo,
        margins: {
          top: 10,
          bottom: 12,
          left: 10,
          right: 10,
        },
        // debug: true,
      };

      htmlToPDF(container, pdfOptions, (blob) => {
        if (blob) {
          // 写到本地
          // const url = URL.createObjectURL(blob);
          // const a = document.createElement('a');
          // a.href = url;
          // a.download = `${projectNo}.pdf`;
          // a.click();
          resolve(blob);
        } else {
          reject(new Error('PDF生成失败'));
        }
      });
    });
  };

  // 上传PDF到S3
  const uploadPDFToS3 = async (blob) => {
    updateButtonState('下载中', true);

    if (!token) {
      throw new Error('S3令牌不存在');
    }

    const s3url = `https://mss.sankuai.com/${token.bucketName}`;
    const formData = new FormData();
    const pdfKey = `${token.dir}${genStr()}${file_name_separator}${projectNo}.pdf`;

    // 准备上传参数
    const { policy, signature, awsaccessKeyId } = token;
    const params = {
      policy, key: pdfKey, signature, awsaccessKeyId,
    };

    // 设置表单数据
    Object.entries(params).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append('file', blob);

    // 上传到S3
    const response = await axiosInstance.post(s3url, formData);

    if (response?.status !== 200) {
      throw new Error('上传PDF失败');
    }

    return pdfKey;
  };

  // 下载PDF文件
  const downloadPDFFile = async (pdfKey) => {
    const response = await downloadProject({
      fileKey: pdfKey,
      projectNo,
    });
    return response;
  };

  // 主下载流程
  const download = async () => {
    try {
      // 步骤1: 生成PDF
      const pdfBlob = await generatePDF();

      // 步骤2: 上传到S3
      const pdfKey = await uploadPDFToS3(pdfBlob);

      // 步骤3: 获取下载链接并打开
      const downloadUrl = await downloadPDFFile(pdfKey);

      // 步骤4: 打开下载链接
      window.open(downloadUrl);

      // 恢复按钮状态
      updateButtonState('下载', false);
    } catch (error) {
      console.error('下载过程发生错误:', error);
      Toast.fail({ title: error.message || '下载失败' });
      updateButtonState('下载', false);
    }
  };

  useEffect(() => {
    getS3Token().then((res) => {
      update((t) => {
        t.token = res;
      });
    });
  }, []);

  return (
    <>
      {
        applyFlag && (
          <Button
            className="h-u-info"
            style={{ marginRight: 12 }}
            onClick={revoke}
          >
            撤回申报
          </Button>
        )
      }
      <Button
        className="h-u-info"
        style={{ marginRight: 12 }}
        onClick={
          download
        }
        disabled={
          downloadBtnConfig.disabled
        }
      >
        {
          downloadBtnConfig.text
        }
      </Button>
      <Button
        className="h-u-info"
        style={{ marginRight: 12 }}
        onClick={() => {
          if (!applyFlag && (formType === 'scientist' || formType === 'innovate')) {
            return history.replace({ pathname: `/apply/${formType}` });
          }
          return history.replace({ pathname: '/home' });
        }}
      >
        退出预览
      </Button>
    </>
  );
};

export default UserAction;
